import { createSlice } from "@reduxjs/toolkit";

export const SelectTitliGameTime = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.gameTimer
export const SelectTitliCurrentGameTime = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.current_game_time
export const SelectTitliNextGameTime = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.next_game_time
export const SelectTitliCoupenValue = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.coupen_value
export const SelectTitliUserWallet = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.user_wallet
export const SelectTitliLastWinCard = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.last_win_Card
export const SelectTitliTimeSlot = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.TIME_SLOT
export const SelectTitliAdvanceDrawSelectTime = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.ADVANCE_DRAW_SELECT_TIME
export const SelectTitliLastSaleAmount = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.last_sale_amount
export const SelectTitliLastTicketId = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.last_ticket_id
export const SelectTitliLotteryReport = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.lottery_Report
export const SelectTitliClaimTicket = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.claim_ticket_id
export const SelectTitliClaimTicketRecord = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.claim_ticket_record
export const SelectTitliReprintList = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.rePrint_list
export const SelectTitliResultData = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.result_data
export const SelectTitliAutoResultData = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.autoResultData
export const SelectTitliAnnoucements = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.annoucements
export const SelectTitliPreviewsTime = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.previews_game_time
export const SelectTitliGameID = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.game_id
export const SelectTitliWinLoseRecord = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.win_lose
export const selectTitliPickResultDates = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.PICK_Result_Dates;
export const selectTitliPickResultTime = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.PICK_Result_time;
export const selectTitliTitliPrint = ({ gameInfoTitliSlice }) => gameInfoTitliSlice.Print_data;


const gameInfoTitliSlice = createSlice({
  name: "gameInfoTitliSlice",
  initialState: {
    gameTimer: true,
    current_game_time: null,
    next_game_time: null,
    coupen_value: null,
    user_wallet: 0,
    last_win_Card: [],
    TIME_SLOT: [],
    ADVANCE_DRAW_SELECT_TIME: [],
    last_sale_amount: null,
    last_ticket_id: null,
    lottery_Report: [],
    PICK_Result_Dates: [],
    PICK_Result_time: {},
    claim_ticket_id: '',
    claim_ticket_record: {},
    rePrint_list: [],
    Print_data: [],
    result_data: [],
    result_data_dates: [],
    autoResultData: [],
    annoucements: '',
    previews_game_time: null,
    game_id: '',
    win_lose: {}
  },
  reducers: {
    SET_TITLI_GAME_TIMER: (state, { payload }) => { state.gameTimer = payload },
    SET_TITLI_CURRENT_GAME_TIME: (state, { payload }) => { state.current_game_time = payload },
    SET_TITLI_NEXT_GAME_TIME: (state, { payload }) => { state.next_game_time = payload },
    SET_TITLI_COUPEN_VALUE: (state, { payload }) => { state.coupen_value = payload },
    SET_TITLI_USER_WALLET: (state, { payload }) => { state.user_wallet = payload },
    SET_TITLI_LAST_WIN_CARD: (state, { payload }) => { state.last_win_Card = [...payload] },
    SET_TITLI_TIME_SLOT: (state, { payload }) => { state.TIME_SLOT = [...payload] },
    SET_TITLI_ADVANCE_DRAW_SELECT_TIME: (state, { payload }) => { state.ADVANCE_DRAW_SELECT_TIME = [...payload] },
    SET_TITLI_LAST_SALE_AMOUNT: (state, { payload }) => { state.last_sale_amount = payload },
    SET_TITLI_LAST_TICKET_ID: (state, { payload }) => { state.last_ticket_id = payload },
    SET_TITLI_LOTTERY_REPORT: (state, { payload }) => { state.lottery_Report = [...payload] },
    SET_TITLI_CLAIM_TICKET_ID: (state, { payload }) => { state.claim_ticket_id = payload },
    SET_TITLI_CLAIM_TICKET_RECORD: (state, { payload }) => { state.claim_ticket_record = { ...payload } },
    SET_TITLI_REPRNT_LIST: (state, { payload }) => { state.rePrint_list = [...payload] },
    SET_TITLI_RESULT_DATA: (state, { payload }) => { state.result_data = [...payload] },
    SET_TITLI_AUTO_RESULT_DATA: (state, { payload }) => { state.autoResultData = [...payload] },
    SET_TITLI_ANNOUCEMENTS: (state, { payload }) => { state.annoucements = payload },
    SET_TITLI_PREVIEWS_GAME_TIME: (state, { payload }) => { state.previews_game_time = payload },
    SET_TITLI_TR_CODE: (state, { payload }) => { state.game_id = payload },
    SET_TITLI_WIN_LOSE_RECORD: (state, { payload }) => { state.win_lose = payload },
    SET_RESULT_DATES_TITLI: (state, action) => {
      state.PICK_Result_Dates = [...action.payload];
    },
    SET_RESULT_TIME_TITLI: (state, action) => {
      state.PICK_Result_time = { ...action.payload };
    },
    SET_TITLI_PRINT_DATA: (state, action) => {
      state.Print_data = { ...action.payload };
    },
    clearTitliWinLoseRecord: (state) => {
      state.win_lose = {};
    }
  }
})





export const {
  SET_TITLI_GAME_TIMER, SET_TITLI_CURRENT_GAME_TIME, SET_TITLI_NEXT_GAME_TIME,
  SET_TITLI_COUPEN_VALUE, SET_TITLI_USER_WALLET, SET_TITLI_LAST_WIN_CARD, SET_TITLI_TIME_SLOT,
  SET_TITLI_ADVANCE_DRAW_SELECT_TIME, SET_TITLI_LAST_SALE_AMOUNT, SET_TITLI_LAST_TICKET_ID,
  SET_TITLI_LOTTERY_REPORT, SET_TITLI_CLAIM_TICKET_ID, SET_TITLI_CLAIM_TICKET_RECORD, SET_TITLI_PRINT_DATA,
  SET_TITLI_REPRNT_LIST, SET_TITLI_RESULT_DATA, SET_TITLI_AUTO_RESULT_DATA, SET_TITLI_ANNOUCEMENTS,
  SET_TITLI_PREVIEWS_GAME_TIME, SET_TITLI_TR_CODE, SET_TITLI_WIN_LOSE_RECORD, SET_RESULT_DATES_TITLI, SET_RESULT_TIME_TITLI, clearTitliWinLoseRecord

} = gameInfoTitliSlice.actions;

export default gameInfoTitliSlice.reducer;